import { Card, Form } from 'antd';
import React, { useState } from 'react';
import { UrlCluster } from '../../urlClusters/types';
import AddClusterStep from './AddClusterStep';
import AddUrlsStep from './AddUrlsStep';

type Props = {
    websiteGuid: string;
    clusters: UrlCluster[];
    maximumAllowedUrls: number;
    onFinish: () => void;
};

export default function AddServiceableUrlsWizard({ websiteGuid, clusters, maximumAllowedUrls, onFinish }: Props) {
    const [isAddingCluster, setIsAddingCluster] = useState<boolean>(false);
    const [selectedCluster, setSelectedCluster] = useState<string>('');

    const handleClusterStepFinished = (newClusterGuid: string) => {
        setSelectedCluster(newClusterGuid);
        setIsAddingCluster(false);
    };

    return (
        <Card bordered={false}>
            <Form
                layout="vertical"
                className="add-urls-and-cluster-form"
            >
                {isAddingCluster && (
                    <AddClusterStep
                        websiteGuid={websiteGuid}
                        onFinish={handleClusterStepFinished}
                        onCancel={() => setIsAddingCluster(false)}
                    />
                )}

                {!isAddingCluster && (
                    <AddUrlsStep
                        websiteGuid={websiteGuid}
                        clusters={clusters}
                        selectedCluster={selectedCluster}
                        maximumAllowedUrls={maximumAllowedUrls}
                        onClusterChange={setSelectedCluster}
                        onAddCluster={() => setIsAddingCluster(true)}
                        onFinish={onFinish}
                    />
                )}
            </Form>
        </Card>
    );
}
